module.exports = __webpack_public_path__ + "static/step-to-bulid-ml-model-c98fd6fce87f08f840b0b35dfea48548.png";